import React, { useState } from "react";
import moment from "moment";
import "./MiniCalendar.css";

export default function MiniCalendarWithBlocks({ appointments }) {
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));

  // Helper: Get appointment color based on type/status
  const getApptColor = (appt) => {
    if (['holiday','Leave'].includes(appt.type)) return 'lightcoral';
    if (appt.type === 'Task') return 'yellow';
    if (appt.type === 'FlowTask') return '#c7d2fe';
    if (appt.status === 'Completed') return 'lightgreen';
    if (appt.status === 'Skipped') return 'antiquewhite';
    if (appt.status === 'scheduled') return 'lightsteelblue';
    if (appt.status === 'inprogress') return 'aquamarine';
    return 'grey';
  };

  // Map appointments by local date
  const apptMap = appointments.reduce((acc, appt) => {
    const dateStr = moment(appt.start).local().format("YYYY-MM-DD");
    if (!acc[dateStr]) acc[dateStr] = [];
    acc[dateStr].push(appt);
    return acc;
  }, {});

  // Change month
  const changeMonth = (dir) => {
    setCurrentMonth(currentMonth.clone().add(dir, "month"));
  };

  // Generate days for current month
  const startOfMonth = currentMonth.clone().startOf("month");
  const endOfMonth = currentMonth.clone().endOf("month");
  const days = [];
  for (
    let day = startOfMonth.clone();
    day.isBefore(endOfMonth) || day.isSame(endOfMonth, "day");
    day.add(1, "day")
  ) {
    days.push(day.clone());
  }

  // Appointments for selected date
  const dayAppointments = apptMap[selectedDate] || [];

  return (
    <div className="mini-calendar-container">
      {/* Month Navigation */}
      <div className="month-navigation">
        <button onClick={() => changeMonth(-1)}>&lt;</button>
        <h4>{currentMonth.format("MMMM YYYY")}</h4>
        <button onClick={() => changeMonth(1)}>&gt;</button>
      </div>

      {/* Weekday Headers */}
      <div className="mini-weekdays">
        {["S","M","T","W","T","F","S"].map((d) => (
          <div key={d} className="mini-weekday">{d}</div>
        ))}
      </div>

      {/* Day Grid */}
      <div className="mini-days-grid">
        {days.map((day) => {
          const dateStr = day.format("YYYY-MM-DD");
          const isSelected = dateStr === selectedDate;
          const dayAppointments = apptMap[dateStr] || [];

          return (
            <div
              key={dateStr}
              className={`mini-day ${isSelected ? "selected" : ""}`}
              onClick={() => setSelectedDate(dateStr)}
            >
              <div className="day-number">{day.date()}</div>
              <div className="mini-appt-blocks">
                {dayAppointments.slice(0, 3).map((appt) => (
                  <div
                    key={appt._id}
                    className="mini-appt"                    
                    style={{ background: getApptColor(appt), color:"black" }}
                    title={`${appt.title} - ${appt.type} - ${appt.status}`}
                  >
                    {moment(appt.start).local().format("HH:mm")}
                  </div>
                ))}
                {dayAppointments.length > 3 && (
                  <div className="more-appts">+{dayAppointments.length - 3}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Daily Agenda */}
      <div className="day-agenda">
        <h4>{moment(selectedDate).format("dddd, MMMM D, YYYY")}</h4>
        {dayAppointments.length === 0 ? (
          <p style={{ textAlign: "center", color: "#888", fontSize: "14px" }}>
            No appointments.
          </p>
        ) : (
          <div className="appointments-list">
            {dayAppointments.map((appt) => (
              <div
                key={appt._id}
                className="appointment"
                style={{
                  background: getApptColor(appt),
                  color: "black",
                  padding: "6px 8px",
                  borderRadius: "4px",
                  fontSize: "0.95rem",
                  marginBottom: "6px",
                }}
              >
                <strong>{moment(appt.start).local().format("HH:mm")}</strong> - {appt.title} - {appt.status} - {appt.type}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
